<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="error error-6 d-flex flex-row-fluid bgi-size-cover bgi-position-center"
      :style="{
        backgroundImage: `url(${appErrorConfig.image})`
      }"
    >
      <!-- begin:: Content -->
      <div class="d-flex flex-column flex-row-fluid text-center">
        <h1
          class="error-title font-weight-boldest text-white mb-12"
          style="margin-top: 12rem;"
        >
          {{ appErrorConfig.title }}
        </h1>
        <p class="display-4 font-weight-bold text-white">
          {{ appErrorConfig.subTitle }}
          <br />
          {{ appErrorConfig.detail }}
          <br />
        </p>
      </div>
      <!-- end:: Content -->
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/error/error-6.scss";
</style>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Error-6",
  mounted() {},
  computed: {
    ...mapGetters(["appErrorConfig"])
  }
};
</script>
